module.exports = __webpack_public_path__ + "img/a-1.2.608aa58c.jpg";